<template>
  <div class="increase-edit-padding">
    <a-spin :spinning="loading">
      <a-skeleton v-show="loading" :paragraph="{rows: 10}" />
    </a-spin>
    <div v-show="!loading">
      <!-- 表单 -->
      <a-form :form="editForm" @submit="handleSubmit" autocomplete="off">
        <!-- 名称-英文美国 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="English Name"
        >
          <a-input
            placeholder="English Name"
            v-decorator="[
              'enName',
              {rules: [{ required: true, message: 'Please input English Name.' }]}
            ]"
          ></a-input>
        </a-form-item>
        <!-- 名称-中文繁体 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Chinese Name"
        >
          <a-input
            placeholder="Chinese Name"
            v-decorator="[
              'twName',
              {rules: [{ required: false, message: 'Please input Chinese Name.' }]}
            ]"
          ></a-input>
        </a-form-item>
        <!-- 启用标志 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Eabled"
        >
          <a-switch
            v-decorator="[
              'enabledFlag',
              { valuePropName: 'checked' }
            ]"
          ></a-switch>
        </a-form-item>
        <!-- 排序 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Sort No."
          v-show="false"
        >
          <a-input-number :min="0" :max="10000" v-decorator="[ 'sortNum']" />
        </a-form-item>
        <!-- 隐藏域 -->
        <a-form-item v-show="false"><a-input v-decorator="['id']"/></a-form-item>
        <!-- 按钮 -->
        <a-form-item v-bind="buttonCol">
          <a-row class="btn-box" style="padding-left: 16.5%;">
            <a-button type="primary" html-type="submit" :loading="saving" @click="handleSubmit">Save</a-button>
            <a-button style="margin-left: 8px;" :loading="saving" @click="handleGoBack">Cancel</a-button>
          </a-row>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import pick from 'lodash.pick'
import FooterToolBar from '@/components/FooterToolbar'
import SpecialrequesApi from '@/api/dict/api-specialrequest'

export default {
  name: 'SpecialrequestEdit',
  components: {
    FooterToolBar
  },
  props: {
    record: {
      type: [String, Object],
      default: null
    }
  },
  data () {
    return {
      // 保存状态
      saving: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 24 }
        }
      },
      editForm: this.$form.createForm(this),
      createFlag: false,
      // 加载中
      loading: true
    }
  },
  mounted () {
    this.initData(this.record)
  },
  methods: {
    async initData (data) {
      this.loading = true
      var formData = null
      var createFlag = true
      if (data === '') {
        // 新增
        formData = { 'id': null, 'enName': null, 'twName': null, 'sortNum': '0', 'enabledFlag': true }
      } else {
        createFlag = false
        // 编辑
        formData = pick(data, ['id', 'enName', 'twName', 'sortNum', 'enabledFlag'])
        if (formData.enabledFlag !== null && formData.enabledFlag === '1') {
          formData.enabledFlag = true
        } else {
          formData.enabledFlag = false
        }
      }
      this.createFlag = createFlag
      this.editForm.setFieldsValue(formData)
      this.loading = false
    },
    loadAllDeptList () {
      return SpecialrequesApi.query(Object.assign({ curPage: 1, pageSize: 1000 }, {}))
    },
    handleGoBack () {
      this.$emit('onGoBack')
    },
    handleSubmit (e) {
      e.preventDefault()
      this.saving = true
      this.editForm.validateFields((err) => {
        // 如果校验失败直接返回
        if (err) {
          return
        }
        var formData = this.editForm.getFieldsValue()
        formData.enabledFlag = formData.enabledFlag ? '1' : '0'
        // 添加
        if (formData.id === null) {
          SpecialrequesApi.add(formData).then(res => {
            if (!this.mixinProcessHasBizErrorNotification(res)) {
              this.mixinProcessSuccessNotification('Save successfully !')
              this.handleGoBack()
            }
          }).finally(() => {
            this.saving = false
          })
        }
        // 修改
        if (formData.id !== null) {
          SpecialrequesApi.update(formData.id, formData).then(res => {
            if (!this.mixinProcessHasBizErrorNotification(res)) {
              this.mixinProcessSuccessNotification('Update successfully !')
              this.handleGoBack()
            }
          }).finally(() => {
            this.saving = false
          })
        }
      })
    }
  }
}
</script>
